import { possessive } from '@shared';
import { Copy, FlaskConical, MoreVertical, Pencil, Trash2, Unlink } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from './ui/button';
import { cn } from '../lib/utils';
import React from 'react';

interface ActionMenuProps {
  actions: JSX.Element[];
  disabled?: boolean;
  className?: string;
}

export function FundingSourceActionMenu({ actions, disabled, className }: ActionMenuProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={cn(
            'h-8 w-8 p-0 text-gray-700 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0',
            className,
          )}
          disabled={disabled}
        >
          <span className="sr-only">Open menu</span>
          <MoreVertical className="h-4 w-4 " />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <ActionMenu actions={actions} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function ActionMenu({ actions }: { actions: React.ReactNode[] }) {
  return (
    <>
      {actions.map((action, index) => (
        <React.Fragment key={index}>{action}</React.Fragment>
      ))}
    </>
  );
}

interface EditActionProps {
  onClick: (open: boolean) => void;
}

export function EditAction(props: EditActionProps) {
  return (
    <DropdownMenuItem
      onClick={() => props.onClick(true)}
      className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm"
    >
      <Pencil className="h-4 w-4" />
      <span>Edit</span>
    </DropdownMenuItem>
  );
}

interface DeleteActionProps {
  onClick: (removeFundingSource: any) => void;
}

export function DeleteAction(props: DeleteActionProps) {
  return (
    <DropdownMenuItem
      onClick={props.onClick}
      className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-red-700"
    >
      <Trash2 className="h-4 w-4" />
      <span>Delete</span>
    </DropdownMenuItem>
  );
}

interface DebugIrrActionProps {
  onClick: () => void;
}

export function DebugIrrAction(props: DebugIrrActionProps) {
  return (
    <DropdownMenuItem
      onClick={props.onClick}
      className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-indigo-600"
    >
      <FlaskConical className="h-4 w-4" />
      <span>IRR Debug Mode</span>
    </DropdownMenuItem>
  );
}

interface MirrorToPartnerActionProps {
  partnerFirstName: string;
  onClick: () => void;
}

export function MirrorToPartnerAction(props: MirrorToPartnerActionProps) {
  return (
    <DropdownMenuItem
      onClick={props.onClick}
      className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm"
    >
      <Copy className="h-4 w-4" />
      <span>Also add to {possessive(props.partnerFirstName)} plan</span>
    </DropdownMenuItem>
  );
}

interface UnlinkActionProps {
  onClick: () => void;
}

export function UnlinkAction(props: UnlinkActionProps) {
  return (
    <DropdownMenuItem
      onClick={props.onClick}
      className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-amber-700"
    >
      <Unlink className="h-4 w-4" />
      <span>Unlink from partner</span>
    </DropdownMenuItem>
  );
}
